import _ from 'underscore';
import $ from 'jquery';

export function request(game, url, params) {
  var options = _.extend(
    {
      method: 'GET'
    },
    params
  );
  var endpoint = '/api/' + game + '/' + url;

  return $.ajax({
    url: endpoint,
    method: options.method,
    xhrFields: {
      withCredentials: true
    },
    contentType: 'application/json',
    dataType: 'json',
    processData: false,
    data: JSON.stringify(options.body)
  });
}
